module.exports = __webpack_public_path__ + "img/Banner-EngineersWorking-dwnszd.067f757b.jpg";